import tehminaImg from '../../assets/team/IMG_9151.JPG';
import img2 from '../../assets/team/IMG_9121.JPG';
import img4 from '../../assets/team/IMG_9123.JPG';
import img7 from '../../assets/team/alena.jpeg';
import emptyUser from '../../assets/team/user.png';
import img9 from '../../assets/team/annaGrigoryan.jpeg';
import mkrtum from '../../assets/team/mkrtum.jpeg';
import anushmelkonyan from '../../assets/team/anush.png';
import img8 from '../../assets/team/IMG_3763.jpeg';
import cfo from '../../assets/team/cfo.png';
import davidManukyan from '../../assets/team/davidManukyan.jpeg';
import monika from '../../assets/team/monika.PNG';
import michael from '../../assets/team/Michael.png';
import irina from '../../assets/team/irina.png'
import chris from '../../assets/team/chris.png'

export const teamMembersKeys = [
  { id: 1, key: 'tehmina', imgSrc: tehminaImg, imgClass: false },
  { id: 2, key: 'michael', imgSrc: michael, imgClass: true },
  { id: 3, key: 'anushmelkonyan', imgSrc: anushmelkonyan, imgClass: true },
  { id: 4, key: 'irina', imgSrc: irina, imgClass: false },
  { id: 5, key: 'gilMata', imgSrc: img4, imgClass: false },
  { id: 15, key: 'chris', imgSrc: chris, imgClass: true },
  { id: 6, key: 'user7', imgSrc: img7, imgClass: true },
  { id: 7, key: 'cfo', imgSrc: cfo, imgClass: false },
  { id: 8, key: 'user2', imgSrc: img2, imgClass: false },
  { id: 9, key: 'user8', imgSrc: img8, imgClass: false },
  { id: 10, key: 'annaGrigoryan', imgSrc: img9, imgClass: false },
  { id: 11, key: 'davidManoukian', imgSrc: davidManukyan, imgClass: false },
  { id: 12, key: 'mkrtumAbrahamyan', imgSrc: mkrtum, imgClass: false },
  { id: 13, key: 'user3', imgSrc: emptyUser, imgClass: false },
  { id: 14, key: 'monikaSar', imgSrc: monika, imgClass: false },
];
